<template>
  <div
    class="product-list-content-block"
    :class="{
      'product-list-content-block--images': !hasCarousel && content.images,
      'product-list-content-block--carousel': hasCarousel && content.images && content.images.length > 1
    }"
    v-if="content.longDescription"
  >
    <product-content-block
      class="product-list__content-block"
      :show-carousel="hasCarousel"
      :headline="content.displayName"
      :text="content.longDescription"
      :images="content.images"
      type="productList"
      :use-read-more="false"
    />

    <product-content-block
      v-if="scaleText"
      class="product-list__content-block"
      :text="scaleText"
    />
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import ProductContentBlock from '../../components/productContentBlock/productContentBlock.vue';
  import type ProductContent from '../../types/ProductContent';
  import {ProductContentBlockSettings} from '../productContentBlock/productContentBlockSettings';
  import diContainer from '../../utilities/js/diContainer/diContainer';

  @Options({
    name: 'product-list-content-block',
    components: {
      ProductContentBlock
    }
  })
  export default class ProductListContentBlock extends Vue {
    @Prop({default: false})
    showCarousel!: boolean;

    @Prop({required: true})
    content: ProductContent;

    @Prop()
    scaleText: string;

    settings: ProductContentBlockSettings = diContainer.get('productContentBlockSettings');
    hasCarousel: boolean = this.showCarousel || this.settings.productlistPageBottomWithCarousel;
  }
</script>
